import { FC } from 'react';

export const BetaBadge: FC = () => (
  <span
    style={{
      marginLeft: 6,
      padding: '1px 5px',
      borderRadius: 3,
      background: '#5a4a7a',
      color: '#ffffff',
      fontSize: 9,
      fontWeight: 600,
      textTransform: 'uppercase',
      verticalAlign: 'middle',
    }}>
    Beta
  </span>
);
